export enum DeviceStatusEnum {
    Deleted,
    Available,
    Rented,
    Damaged
}
